import NProgress from "nprogress";

NProgress.configure({
  showSpinner: false,
  trickleSpeed: 150,
  minimum: 0.2,
});

export { NProgress };
